"use client";
import { Input } from "@/components/ui/Input";
import { useTranslations } from "@/i18n/client";
import { useSearchParams } from "next/navigation";
import { useSearchQuery } from "./hooks/useProductSearch";
import styles from "./index.module.css";

export const SearchField = () => {
  const search = useSearchParams().get("q") || "";
  const [searchValue, setValue] = useSearchQuery(search);
  const t = useTranslations("search");
  const handleClear = () => {
    setValue("");
  };
  return (
    <div className={styles.searchField}>
      <Input
        defaultValue={search}
        onChange={(e) => setValue(e.target.value)}
        onClear={handleClear}
        value={searchValue ?? ""}
        placeholder={t("search")}
        variant="search"
      />
    </div>
  );
};

export const SearchFallback = () => (
  <div className={styles.searchField}>
    <Input placeholder="Search" variant="search" />
  </div>
);
